import {Typography} from 'components/Typography';
import classNames from 'classnames';
import React, {FC} from 'react';
import style from './style.module.scss';

// eslint-disable-next-line no-shadow
export enum RadioHeightType {
    Default = 'default',
    Height34 = 'height34',
}

export interface IProps {
    count?: number | string;
    height?: RadioHeightType;
    isChecked: boolean;
    name: string;
    onChange: () => void;
    title: string;
}

export const Radio: FC<IProps> = ({count, height = RadioHeightType.Default, isChecked, name, onChange, title}) => {
    return (
        <label className={classNames(style.main, {[style.isChecked]: isChecked, [style[height]]: height})}>
            <input
                data-skeleton-item={true}
                checked={isChecked}
                className={style.radio}
                name={name}
                onChange={onChange}
                type={'radio'}
            />
            <span data-skeleton-item={true} className={style.checkmark}></span>
            <Typography data-skeleton-item={true} className={style.content} variant={'label-14-r'}>
                {title}
            </Typography>
            <Typography data-skeleton-item={true} className={style.count} variant={'label-14-r'}>
                {count}
            </Typography>
        </label>
    );
};
